import * as consts from 'consts/consts';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import {
  useIsHRAdmin,
  useIsSuperAdminNonImpersonating,
} from 'utils/models/User';
import { useFeatures } from 'utils/util/features';
import Page from '../Layout/Pages/Page';
import { AdministrationTab } from './administrationTabs';
import {
  ReceivedFeedbackAndRecognitionAdminPage,
  RequestedFeedbackAndRecognitionAdminPage,
} from './ContentAdministration/FeedbackAndRecognitionAdmin';
import OrganizationAudit, {
  AuditEntryType,
} from './PeopleAdministration/Audit/OrganizationAudit';

const FeedbackAndRecognitionAdministrationPage: FC = () => {
  const { formatMessage } = useIntl();
  const { isEnabled } = useFeatures();
  const isHrAdmin = useIsHRAdmin();
  const isSuperAdmin = useIsSuperAdminNonImpersonating();

  const tabs: AdministrationTab[] = [];

  if (
    isEnabled('continuous_feedback') &&
    isEnabled('content_administration') &&
    (isHrAdmin || isSuperAdmin)
  ) {
    tabs.push({
      path: consts.ADMINISTRATION_FEEDBACK_AND_RECOGNITION(formatMessage).path,
      name: consts.ADMINISTRATION_FEEDBACK_AND_RECOGNITION(formatMessage).name,
      content: <ReceivedFeedbackAndRecognitionAdminPage />,
    });

    tabs.push({
      path: consts.ADMINISTRATION_FEEDBACK_AND_RECOGNITION_REQUESTED(
        formatMessage
      ).path,
      name: consts.ADMINISTRATION_FEEDBACK_AND_RECOGNITION_REQUESTED(
        formatMessage
      ).name,
      content: <RequestedFeedbackAndRecognitionAdminPage />,
    });

    tabs.push({
      path: consts.ADMINISTRATION_FEEDBACK_AND_RECOGNITION_AUDIT(formatMessage)
        .path,
      name: consts.ADMINISTRATION_FEEDBACK_AND_RECOGNITION_AUDIT(formatMessage)
        .name,
      content: (
        <OrganizationAudit
          auditEntryTypes={[AuditEntryType.FEEDBACK_MANAGEMENT]}
        />
      ),
    });
  }

  return (
    <Page
      title={consts.ADMINISTRATION_FEEDBACK_AND_RECOGNITION(formatMessage).name}
      forceShowTabs={true}
      tabs={tabs}
    />
  );
};

export default React.memo(FeedbackAndRecognitionAdministrationPage);
